var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"Insights"}},[(_vm.page === 0)?_c('InsightsIntro',{on:{"start":_vm.startInsights}}):_vm._e(),(_vm.page === 1)?_c('InsightsQuestions'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }